// eslint-disable-next-line import/prefer-default-export
export const Sort = Object.freeze({
  Ascending: 'asc',
  Descending: 'desc',
});
